<template>
  <div class="redirect-container p-20">
    <el-alert
      title="「访问日志」已与「操作日志」合并，正在跳转至操作日志..."
      type="info"
      :closable="false"
      show-icon
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'AccessLogRedirect',
  setup() {
    const router = useRouter()
    onMounted(() => {
      setTimeout(() => {
        router.replace('/system/userLog/operationLog/Index')
      }, 300)
    })
  }
})
</script>

<style scoped>
.redirect-container {
  padding: 30px;
}
</style>
